export const productFacts = {
  legalName: 'CalorieScience Healthtech Private Limited (Pte Ltd)',
  contactEmail: 'info@caloriescience.ai',
  address: '160 Robinson Road, #14-04 Singapore Business Federation Center, Singapore 068914',
};
